import * as types from "./mutation-types";
import { leadImportsService } from "@/services";
import { messageHelper } from "@/helpers/message_helper";
import _ from "lodash";

export const fetchLeadImports = async ({ commit }) => {
  commit(types.SET_IS_LOADING, true);

  try {
    const response = await leadImportsService.list();
    commit(types.SET_IMPORT_LEAD_LIST, response.data.data);
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  } finally {
    commit(types.SET_IS_LOADING, false);
  }
};

export const importLeads = async ({ commit }, file) => {
  try {
    const response = await leadImportsService.upload(file);
    commit(types.IMPORT_LEAD_LIST_ADD_ITEM, response.data.data);

    messageHelper.displaySuccess(
      "O arquivo enviado será processado em segundo plano."
    );

    return true;
  } catch (error) {
    let errors = "";

    if (_.get(error, "response.data.file")) {
      errors = errors.concat("<ul>");

      error.response.data.file.forEach(message => {
        errors = errors.concat("<li> - ");
        errors = errors.concat(message);
        errors = errors.concat("</li>");
      });

      errors = errors.concat("</ul>");
    }

    messageHelper.displayError(
      `Não foi possível importar os leads.<br>${errors}`
    );
  }

  return false;
};
